/**
 * SECTION - FILTERS SIDEBAR - LISTENERS
 */

setupEventListenersForFiltersSidebar();

// Creates the event listeners
function setupEventListenersForFiltersSidebar() {
  // On clicking on the button to open or close the filters drawer
  document.querySelectorAll('[data-action="open-filters-sidebar"], [data-action="close-filters-sidebar"]').forEach((element) => {
    element.addEventListener('click', toggleFiltersSidebarHandler);
  });
}

/**
 * SECTION - FILTERS SIDEBAR - GENERAL
 */

// On clicking on the button to open or close the filters drawer
function toggleFiltersSidebarHandler() {
  event.preventDefault();
  toggleSidebar('filters');
}